module.exports = __webpack_public_path__ + "assets/img/404.225e1a6c.png";